<p-card *ngIf="inited" header="Konfiguration ändern" [style]="{'width': '400px', 'margin': 'auto'}">
    <app-config-changer-config #changer [def]="def" [plain]="value"></app-config-changer-config>
    <p-button styleClass="mt-3" icon="fas fa-save" label="Speichern" (onClick)="save()"></p-button>
</p-card>
